// Danish

export default {

  component: {
    jobAdList: {
      title: 'Åbne stillingsopslag',
      jobs: 'job',
      noJobAds: 'Der er i øjeblikket ingen ledige stillinger.',
    },

    jobAdCard: {
      openUntil: date => `Åben indtil ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Mange tak.',
      readyInfo: 'Din ansøgning er nu modtaget, og rekrutteringsmedarbejderen vender tilbage til dig snarest.',
      luck: 'Held og lykke!',
    },

    jobAdSeeYou: {
      title: 'Mange tak.',
      description: 'Din ansøgning er blevet gemt, og vi har sendt et link til forsættelse af ansøgningen på et senere tidspunkt.',
    },

    unpublished: {
      title: 'Ikke offentliggjort',
      info: 'Jobannoncen er endnu ikke blevet offentliggjort',
    },
  },

  page: {},
}
